// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.persona.RentalManagerUserPropertyPersonaLinkWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ListingAlias, RentalManagerGetPersonaLinkResponseDto } from '../..';

interface GetLinkParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_Path =
  '/api/web/v1/users/properties/persona/getLink';

/**
 * Get persona inquiry link for a listing
 */
export const RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink = (
  getParams: GetLinkParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetLinkParams, never, RentalManagerGetPersonaLinkResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
